import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface IndexReference {
  id: number;
  name: string;
}

export interface CombinedIndexDictionary {
  fuelPriceIndexes: IndexReference[];
  papIndexes: IndexReference[];
}

export interface CombinedIndexOption {
  id: number;
  name: string;
  type: 'FuelPriceIndex' | 'PapIndex';
  displayName: string;
}

@Injectable({
  providedIn: 'root',
})
export class DictionaryCombinedIndexService {
  url = '/api/dictionary/combined-index';

  constructor(private http: HttpClient) {}

  getAll(): Observable<CombinedIndexDictionary> {
    return this.http.get<CombinedIndexDictionary>(this.url);
  }

  transformToOptions(data: CombinedIndexDictionary): CombinedIndexOption[] {
    const options: CombinedIndexOption[] = [];

    data.fuelPriceIndexes.forEach((item) => {
      options.push({
        id: item.id,
        name: item.name,
        type: 'FuelPriceIndex',
        displayName: `[Platts] ${item.name}`,
      });
    });

    data.papIndexes.forEach((item) => {
      options.push({
        id: item.id,
        name: item.name,
        type: 'PapIndex',
        displayName: `[PAP] ${item.name}`,
      });
    });

    return options;
  }
}
